import React, { useEffect, useState } from "react";
import { capitalizeFirstLetter } from "../utils/Functions";

const serviceData = [
  { name: "medications management", color: "bg-purple-300" },
  { name: "transfer", color: "bg-amber-300" },
  { name: "personal care", color: "bg-green-300" },
  { name: "Monitoring Vital Signs", color: "bg-lime-300" },
  { name: "back Care", color: "bg-rose-300" },
  { name: "nutrition", color: "bg-yellow-300" },
  { name: "injection", color: "bg-amber-300" },
  { name: "IV fluid", color: "bg-green-300" },
  { name: "catheter care", color: "bg-lime-300" },
];

const filterDataByDate = (data, days) => {
  const today = new Date();
  const pastDate = new Date();
  pastDate.setDate(today.getDate() - days);

  today.setHours(0, 0, 0, 0);
  pastDate.setHours(0, 0, 0, 0);

  return data.filter((item) => {
    const itemDate = new Date(item.createdAt);
    itemDate.setHours(0, 0, 0, 0);
    return itemDate >= pastDate && itemDate <= today;
  });
};

const countUniqueServices = (data) => {
  if (data.length === 0) return [];

  const counts = data.reduce((acc, item) => {
    acc[item.service] = (acc[item.service] || 0) + 1;
    return acc;
  }, {});

  return Object.entries(counts).map(([service, count]) => {
    const serviceInfo = serviceData.find((s) => s.name === service);
    const color = serviceInfo ? serviceInfo.color : "bg-[#def5fa]";

    return {
      name: service,
      count,
      percentage: (count / data.length) * 100,
      color,
    };
  });
};

const ServiceChart = ({ value, data }) => {
  const [serviceCounts, setServiceCounts] = useState([]);

  useEffect(() => {
    let filteredData;
    switch (value) {
      case "Today":
        filteredData = filterDataByDate(data, 0);
        break;
      case "Last 7 days":
        filteredData = filterDataByDate(data, 7);
        break;
      case "Last 30 days":
        filteredData = filterDataByDate(data, 30);
        break;
      default:
        filteredData = data;
        break;
    }

    // console.log("Filtered Data:", filteredData);

    const counts = countUniqueServices(filteredData);
    setServiceCounts(counts);
  }, [value, data]);
  return (
    <div className="w-[98.35%]  bg-white shadow rounded-2xl m-2 pb-2 mt-[10px]">
      <h2 className="text-[14px] ml-2 p-3 font-semibold">
        Bookings By Service Type
      </h2>
      <div className="border-b border-[#D7E4EB] mb-2"></div>
      <div className="space-y-3 ml-5" style={{ marginBottom: 10 }}>
        {serviceCounts.map((service) => (
          <div
            key={service.name}
            className="flex flex-row justify-start gap-24 items-center mt-4"
          >
            <div
              className={`h-7 rounded-lg ${service.color} `}
              style={{
                width: `${service.percentage * 4}%`,
                maxWidth: "600px",
              }}
            >
              <span
                className="text-[12px] ml-3 w-[100%]"
                style={{
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              >
                {capitalizeFirstLetter(service.name)}
              </span>
            </div>
            <div className="text-[#4e9bed] text-[12px]">
              {Math.round(service.percentage)}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceChart;
